import React from 'react';
import styles from './Terms&Conditions.module.css';
import Section from './Section/Section';
import Subsection from './SubSection/SubSection';

const TermsAndConditions: React.FC = () => {
  const logoSrc =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/07ab6bdf4dbd2cfab62d8d864a791eacb84383c1ed6ee7836685e3bccc7ae357' +
    '?placeholderIfAbsent=true&apiKey=548f57046a67499a898e18b52d3ebffe';

  return (
    <main className={styles.termsContainer}>
      <div className={styles.contentWrapper}>
        <header className={styles.logoWrapper}>
          <img src={logoSrc} alt="GemLux Logo" className={styles.logo} />
        </header>
        <h1 className={styles.pageTitle}>GemLux Terms and Conditions of Use</h1>

        <Section title="Introduction">
          Welcome to GemLux. By accessing or using our platform and services, you agree to comply with and be bound by
          the following terms and conditions of use (T&Cs). If you do not agree with these terms, you must not use our
          services.
        </Section>

        <Section title="Definitions">
          <ul>
            <li>
              <strong>Company:</strong> Refers to Porolis Technologies Pte Ltd.
            </li>
            <li>
              <strong>Platform:</strong> The GemLux website and associated applications on devices KROMA™, KRISTA™.
            </li>
            <li>
              <strong>User:</strong> Anyone who uses the GemLux services.
            </li>
            <li>
              <strong>Service:</strong> The gemstone scanning, evaluation, and information management services provided
              by GemLux.
            </li>
            <li>
              <strong>Content:</strong> All information, data, text, software, and images, video, reports, AI machine
              learning models etc available on the platform.
            </li>
          </ul>
        </Section>

        <Section title="User Accounts and Responsibilities">
          <Subsection
            title="Account Creation"
            content={`To use certain features of our platform, you must create an account, 
            providing accurate and complete information.`}
          />
          <Subsection
            title="Account Security"
            content={`You are responsible for maintaining the confidentiality of your account 
            credentials and for all activities that occur under your account.`}
          />
          <Subsection
            title="Accurate Information"
            content={`Users must provide accurate and up-to-date information 
            during registration and when using our service.`}
          />
        </Section>

        <Section title="Services and Usage">
          <Subsection
            title="Service Description"
            content={`GemLux offers services for scanning, evaluating, 
            and managing gemstones through our platform.`}
          />
          <Subsection
            title="Permitted Use"
            content="You may use our services for lawful purposes and in accordance with these T&Cs."
          />
        </Section>

        <Section title="Subscription Plans and Payments">
          <Subsection
            title="Plans"
            content={`GemLux offers various subscription plans, including free and 
            paid options for individuals and companies.`}
          />
          <Subsection
            title="Billing"
            content={`Payments for subscription plans are billed periodically 
            as specified at the time of purchase.`}
          />
          <Subsection
            title="Cancellations and Refunds"
            content={`You may cancel your subscription according to our cancellation 
            policy. Refunds are subject to our refund policy.`}
          />
        </Section>

        <Section title="Content and Intellectual Property">
          <Subsection
            title="User Content"
            content={`Users retain ownership of the content they create but grant GemLux 
            a license to use it as needed to provide our services.`}
          />
          <Subsection
            title="Company Content"
            content="GemLux owns all content and intellectual property related to the platform."
          />
          <Subsection
            title="Prohibited Content"
            content="Users must not upload content that is offensive, infringing, or illegal."
          />
        </Section>

        <Section title="Privacy Policy">
          <Subsection
            title="Data Collection"
            content={`We collect personal data to provide and improve our services. 
            For more information, please see our Privacy Policy.`}
          />
          <Subsection
            title="Data Protection"
            content="We implement measures to protect your data from unauthorized access and use."
          />
          <Subsection
            title="User Rights"
            content={`Users have rights regarding their personal data, including 
            the right to access, correct, and delete their information.`}
          />
        </Section>

        <Section title="Termination">
          <Subsection
            title="Termination by User"
            content={`You may terminate your account at any time by 
            following the instructions on our platform.`}
          />
          <Subsection
            title="Termination by Company"
            content="GemLux reserves the right to suspend or terminate accounts that violate these T&Cs."
          />
        </Section>

        <Section title="Disclaimers and Limitation of Liability">
          <Subsection
            title="Service Availability"
            content="We do not guarantee that our services will be uninterrupted or error-free."
          />
          <Subsection
            title="Limitation of Liability"
            content={`GemLux is not liable for any damages arising 
            from the use of our platform and services.`}
          />
        </Section>

        <Section title="Governing Law and Dispute Resolution">
          <Subsection title="Governing Law" content="These T&Cs are governed by the laws of Singapore." />
          <Subsection
            title="Dispute Resolution"
            content={`Disputes will be resolved through arbitration or mediation as 
            specified in our dispute resolution policy.`}
          />
        </Section>

        <Section title="Changes to the Terms and Conditions">
          <Subsection title="Modification Rights" content="We may modify these T&Cs at any time." />
          <Subsection
            title="Notification of Changes"
            content="We will notify users of significant changes through our platform or via email."
          />
        </Section>

        <Section title="Contact Information">
          <p>For support or queries regarding these T&Cs, please contact us at</p>
          <a href="mailto:use_terms@porolis.com" className={styles.contactEmail}>
            use_terms@porolis.com
          </a>
        </Section>
      </div>
    </main>
  );
};
export default TermsAndConditions;
